module.exports = __webpack_public_path__ + "img/collection-engagementRingsRingsets@2x.64806bd.jpg";